import io, { Socket } from "socket.io-client";
import { Platform } from "react-native";
import { EventEmitter } from "events";
import LS from "../utils/localStorageUtils";
import { env } from "../utils/env";

let socket: Socket | null = null;

let socketBoundIdentity: { playerId: string; token: string | null } | null =
  null;

export const socketEvents = Platform.OS !== 'web' ? new EventEmitter() : null;

if (socketEvents) {
  console.log("✅ socketEvents EventEmitter created for platform:", Platform.OS);
} else {
  console.log("🌐 No socketEvents (web platform)");
}

export const getSocket = (playerId: string, username: string) => {
  const token = LS.get("access_token");

  if (
    socket &&
    socketBoundIdentity &&
    (socketBoundIdentity.playerId !== playerId ||
      socketBoundIdentity.token !== token)
  ) {
    closeSocket();
  }

  if (!socket) {
    const socketURL = env("WS_API_URL");

    console.log("🔌 Connecting to WebSocket:", socketURL);

    socketBoundIdentity = { playerId, token };
    socket = io(socketURL, {
      path: "/game-socket.io",
      transports: ["websocket"],
      auth: { token },
      query: { playerId, username },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
    });

    setupConnectionHandlers(socket);

    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.socket = socket;
    }
  }

  return socket;
};

const setupConnectionHandlers = (socket: Socket) => {
  socket.removeAllListeners();
  
  socket.on("disconnect", (reason) => {
    console.warn("🔌 Disconnected:", reason);
    
    if (reason === "io server disconnect") {
      return;
    }

    emitCustomEvent("websocket:recovering", {
      reason,
      timestamp: new Date().toISOString(),
    });
  });

  socket.on("connect", () => {
    console.log("✅ Connected to WebSocket");
  });

  socket.on("websocket:ready", (data) => {
    console.log("✅ WebSocket ready:", data);
    
    emitCustomEvent("websocket:ready", {
      timestamp: data.timestamp,
    });
  });

  socket.on("game:recovering", (data) => {
    console.log("🔄 Game recovering:", data);
  });

  socket.on("game:recovered", (data) => {
    console.log("✅ Game recovered:", data);
  });

  socket.on("reconnect_attempt", (attemptNumber) => {
    console.log(`🔄 Reconnection attempt ${attemptNumber}`);
  });

  socket.on("connect_error", (error) => {
    console.error("❌ Connection error:", error.message);
  });
};

function emitCustomEvent(eventName: string, data: any) {
  console.log(`🎯 Emitting ${eventName} on ${Platform.OS}`);
  
  if (Platform.OS === 'web') {
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent(eventName, {
          detail: data,
          bubbles: true,
          cancelable: false,
        })
      );
      console.log(`✅ Web event dispatched: ${eventName}`);
    }
  } else {
    if (socketEvents) {
      socketEvents.emit(eventName, data);
      const count = socketEvents.listenerCount(eventName);
      console.log(`✅ Native event emitted: ${eventName} (${count} listeners)`);
    } else {
      console.error("❌ socketEvents is null!");
    }
  }
}

export const closeSocket = () => {
  if (socket) {
    console.log("🔌 Closing socket...");
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  socketBoundIdentity = null;
  if (Platform.OS === "web" && typeof window !== "undefined") {
    try {
      delete (window as { socket?: Socket }).socket;
    } catch {
      (window as { socket?: undefined }).socket = undefined;
    }
  }
};